import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import moment from "moment";
import { map, withLatestFrom } from "rxjs/operators";
import { Plant } from "src/model/class/general classes/plant";
import { AccessResult } from "src/components/shared-components/enum/enumAccessControl";
import {
  HistoryTransitStoreAction,
  PlantsStoreAction,
} from "src/components/shared-components/enum/enumStoreAction";
import { HistoryTransit } from "src/model/interface/history-transit";
import { ValidListHandlerService } from "src/service/valid-list-handler.service";
import {
  historyTransitCompleteAddNewTransitInHistoryAction,
  historyTransitRemoveHistoryTransitReleatedToRemovedPlantAction,
} from "../actions/history-transit.actions";
import { selectedPlant } from "../selectors/plant.selectors";

/**
 * Handle generic side ngrx effect for history transit
 */
@Injectable()
export class HistoryTransitEffects {
  constructor(
    private _actions$: Actions,
    private _store: Store,
    private _validListHandlerService: ValidListHandlerService
  ) { }

  public historyTransitRemoveHistoryReleatedToRemovePlantEffect = createEffect(
    () =>
      this._actions$.pipe(
        ofType(PlantsStoreAction.REMOVE_PLANT),
        map((plantAction: any) => plantAction.idPlant),
        map((idPlant: number) =>
          historyTransitRemoveHistoryTransitReleatedToRemovedPlantAction({
            idPlant,
          })
        )
      )
  );

  /**
   * Effect who catch main event and unset specific server key storage
   */
  public historyDeviceAddNewTransitInHistoryEffect = createEffect(() =>
    this._actions$.pipe(
      ofType(
        HistoryTransitStoreAction.HISTORY_TRNASIT_START_ADD_NEW_TRANSIT_IN_HISTORY
      ),
      withLatestFrom(this._store.select(selectedPlant)),
      map((action: any) => {
        const selectedPlant: Plant = action[1];
        const instanceGuid: string = action[0].instanceGuid;
        const address: string = action[0].address;
        const accessResult: AccessResult = action[0]
          .accessResult as AccessResult;
        const code: string = action[0].code;
        const idDevice: number = action[0].idDevice;
        const date = moment().format("DDMMYYYY");
        const time = moment().format("HHmmss");
        const uid: string = action[0].uid;

        const historyTransit: HistoryTransit =
          this._validListHandlerService.buildHistoryTransitObject(
            selectedPlant.ID,
            idDevice,
            instanceGuid,
            address,
            code,
            accessResult,
            date,
            time,
            uid
          );

        return historyTransitCompleteAddNewTransitInHistoryAction({
          historyTransit,
        });
      })
    )
  );
}
